module.exports = __webpack_public_path__ + "img/order.2b749f09.png";